import { withAuthenticationRequired } from '@auth0/auth0-react';
import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import RedirectToModelView from './components/RedirectToModelView';
import RedirectAlias from './pages/RedirectAlias';


const Dashboard = withAuthenticationRequired(React.lazy(() => import('./pages/Dashboard')));
const Home = React.lazy(() => import('./pages/Home'));
const About = React.lazy(() => import('./pages/About'));
const User = withAuthenticationRequired(React.lazy(() => import('./pages/User')));
const Search = React.lazy(() => import('./pages/Search'));
const MyModels = withAuthenticationRequired(React.lazy(() => import('./pages/MyModels')));
const MyModel = React.lazy(() => import('./pages/MyModel'));
const Repositories = withAuthenticationRequired(React.lazy(() => import('./pages/Repositories')));
const Profile = (React.lazy(() => import('./pages/Profile')));
const OrganizationManagement = withAuthenticationRequired(React.lazy(() => import('./pages/OrganizationManagement')));
const RequestModel = React.lazy(() => import('./pages/RequestModel'));
const SystemAdmin = withAuthenticationRequired((React.lazy(() => import('./pages/SystemAdmin'))));
const AppEngines = withAuthenticationRequired((React.lazy(() => import('./pages/AppEngines'))));
const Engine = withAuthenticationRequired((React.lazy(() => import('./pages/Engine'))));
const ChatBot = React.lazy(() => import('./pages/ModelChatBot'));
const Pricing = React.lazy(() => import('./pages/Pricing'));

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   icon: "nc-icon nc-bank",
  //   // component: Dashboard,
  //   layout: "/admin"
  // },
  {
    path: '/search',
    name: 'Search Models',
    icon: 'nc-icon nc-zoom-split',
    // component: Maps,
    layout: '/admin',
    isAuthenticateRequired: false,
  },
  // {
  //   path: '/search',
  //   name: 'Search Models',
  //   icon: 'nc-icon nc-zoom-split',
  //   // component: Maps,
  //   layout: '/admin',
  //   isAuthenticateRequired: false,
  // },
  {
    path: "/requestmodel",
    name: "Request A Model",
    icon: "nc-icon nc-atom",
    layout: "/admin",
    isAuthenticateRequired:false,
  },
  // {
  //   path: '/dashboard',
  //   name: 'Dashboard',
  //   icon: 'nc-icon nc-chart-pie-36',
  //   // component: Dashboard,
  //   layout: '/admin',
  //   isAuthenticateRequired: true,
  // },

  {
    path: '/models',
    name: 'My Models',
    icon: 'nc-icon nc-tile-56',
    // component: Maps,
    layout: '/admin',
    isAuthenticateRequired: true,
  },
  // {
  //   path: "/engines",
  //   name: "App Engines",
  //   icon: "nc-icon nc-money-coins",
  //   // component: Maps,
  //   layout: "/admin",
  //   isAuthenticateRequired:true,
  // },
  // {
  //   path: '/repositories',
  //   name: 'My Repositories',
  //   icon: 'nc-icon nc-box-2',
  //   // component: Maps,
  //   layout: '/admin',
  //   isAuthenticateRequired: true,
  // },
  // {
  //   path: '/organaization',
  //   name: 'Organization  Mgmt.',
  //   icon: 'nc-icon nc-bank',
  //   // component: Maps,
  //   layout: '/admin',
  //   isAuthenticateRequired: true,
  // },
  // {
  //   path: '/profile',
  //   name: 'Profile',
  //   icon: 'nc-icon nc-single-02',
  //   // component: Maps,
  //   layout: '/admin',
  //   isAuthenticateRequired: true,
  // },
 
  {
    path: '/auth',
    name: 'Auth',
    icon: 'nc-icon nc-touch-id',
    // component: Maps,
    layout: '/admin',
    isAuthenticateRequired: false,
  },
  {
    path: '/signup',
    name: 'SignUp',
    icon: 'nc-icon nc-circle-10',
    // component: Maps,
    layout: '/admin',
    isAuthenticateRequired: false,
  },
  // {
  //   pro : true,
  //   path: "/pricing",
  //   name: "UnityPredict Pricing",
  //   icon: "nc-icon nc-money-coins",
  //   // component: <>Rohan</>,
  //   layout: "/admin",
  //   isAuthenticateRequired: false,
  // },
];
export default routes;

export const ModelCentralRoutes = () => {
  return (
    <React.Suspense>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/:alias" element={<RedirectAlias />} />  */}
        <Route path="/about" element={<About />} />
        {/* <Route path="/systemadmin" element={<SystemAdmin />} /> */}
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* <Route path="/user" element={<User />} /> */}
        <Route path="/search" element={<Search />} />
        {/* <Route path="/models" element={<MyModels />}></Route> */}
        <Route path="/models/:id/:mode" element={<MyModel />} />
        {/* <Route path="/models/:id/" element={<RedirectToModelView />} /> */}
        {/* <Route path="/engines" element={<AppEngines />} /> */}
        {/* <Route path="/engines/:engineId" element={<Engine />} /> */}
        {/* <Route path="/repositories" element={<Repositories />} /> */}
        {/* <Route path="/organaization" element={<OrganizationManagement />} />
        <Route path="/requestmodel" element={<RequestModel />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/:publicName" element={<Profile />} /> */}
        <Route path="/chatbot/:modelId" element={<ChatBot />} />
        {/* <Route path="/pricing" element={<Pricing />} /> */}
        <Route path="/profile/:publicName" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </React.Suspense>
  );
};
